import { render, staticRenderFns } from "./NewDecisionDetails.vue?vue&type=template&id=161e2a42&scoped=true"
import script from "./NewDecisionDetails.vue?vue&type=script&lang=js"
export * from "./NewDecisionDetails.vue?vue&type=script&lang=js"
import style0 from "./NewDecisionDetails.vue?vue&type=style&index=0&id=161e2a42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161e2a42",
  null
  
)

export default component.exports